<!-- Page légale : volontairement en français seulement (texte faisant foi), voir CLAUDE.md « i18n » -->
<div class="container cookies-policy">
  <h1>POLITIQUE DE COOKIES</h1>
  <p class="updated">Dernière mise à jour : 30 octobre 2026</p>

  <section class="manage">
    <p>
      Vous pouvez à tout moment accepter, refuser ou modifier votre choix, catégorie par catégorie.
      Refuser n'empêche pas d'utiliser le site.
    </p>
    <button mat-stroked-button type="button" class="manage-button" (click)="openPreferences()">Gérer mes cookies</button>
    @if (consentLabel) {
      <p class="current">Votre choix actuel : {{ consentLabel }}</p>
    }
  </section>

  <h2>Qu'est-ce qu'un cookie ?</h2>
  <p>
    Un cookie (ou traceur) est une information déposée sur votre appareil lors de la visite d'un site : fichier
    cookie, stockage local du navigateur (localStorage), identifiant… Certains sont indispensables au fonctionnement
    du site, d'autres ne sont déposés qu'avec votre accord, conformément à l'article 82 de la loi Informatique et
    Libertés et aux recommandations de la CNIL.
  </p>

  <h2>1. Traceurs strictement nécessaires (sans consentement)</h2>
  <p>Ils servent uniquement au fonctionnement du site et ne permettent pas de vous suivre sur d'autres sites.</p>
  <div class="table-wrapper">
    <table>
      <thead>
        <tr><th>Nom</th><th>Émetteur</th><th>Finalité</th><th>Durée</th></tr>
      </thead>
      <tbody>
        <tr><td>cookie_consent</td><td>PromoDeep</td><td>Mémoriser vos choix sur les cookies quand le bandeau du site est affiché</td><td>6 mois</td></tr>
        <tr><td>FCCDCF, FCNEC</td><td>Google Ireland Ltd</td><td>Mémoriser vos choix quand le message de consentement de Google est affiché</td><td>Fixée par Google</td></tr>
        <tr><td>currentUser</td><td>PromoDeep</td><td>Garder votre session ouverte quand vous êtes connecté(e)</td><td>Jusqu'à la déconnexion</td></tr>
        <tr><td>language, theme</td><td>PromoDeep</td><td>Langue et thème (clair / sombre) choisis</td><td>Jusqu'à modification</td></tr>
        <tr><td>cookies_newsletter, cookies_login, bandeaux et notifications vus</td><td>PromoDeep</td><td>Ne pas réafficher une fenêtre ou un bandeau déjà fermé</td><td>Jusqu'à suppression</td></tr>
        <tr><td>Service worker / cache</td><td>PromoDeep</td><td>Fonctionnement hors ligne de l'application et notifications que vous avez activées</td><td>Jusqu'à suppression</td></tr>
      </tbody>
    </table>
  </div>

  <h2>2. Mesure d'audience (avec votre consentement)</h2>
  <p>
    Google Analytics 4 nous indique comment le site est utilisé (pages vues, durée de visite, provenance) afin de
    l'améliorer. Il n'est chargé qu'après votre accord pour cette mesure.
  </p>
  <div class="table-wrapper">
    <table>
      <thead>
        <tr><th>Nom</th><th>Émetteur</th><th>Finalité</th><th>Durée</th></tr>
      </thead>
      <tbody>
        <tr><td>_ga, _ga_*</td><td>Google Ireland Ltd</td><td>Statistiques de fréquentation</td><td>13 mois maximum</td></tr>
      </tbody>
    </table>
  </div>

  <h2>3. Publicité (avec votre consentement)</h2>
  <p>
    Le script de Google AdSense est chargé dès votre arrivée sur le site, car il affiche le message de consentement
    de Google (plateforme certifiée IAB TCF v2.2) ; les emplacements publicitaires du site et Google Ads (mesure de
    l'efficacité de nos campagnes) ne sont activés qu'après votre accord. Google peut transférer certaines données hors de l'Union
    européenne ; voir la politique de confidentialité de Google : <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">policies.google.com</a>.
  </p>
  <div class="table-wrapper">
    <table>
      <thead>
        <tr><th>Nom</th><th>Émetteur</th><th>Finalité</th><th>Durée</th></tr>
      </thead>
      <tbody>
        <tr><td>_gcl_au</td><td>Google Ireland Ltd</td><td>Mesure des conversions publicitaires</td><td>3 mois</td></tr>
        <tr><td>__gads, __gpi</td><td>Google Ireland Ltd</td><td>Affichage et limitation de la répétition des publicités</td><td>13 mois maximum</td></tr>
      </tbody>
    </table>
  </div>

  <h2>4. Liens d'affiliation</h2>
  <p>
    Quand vous cliquez sur une offre, vous quittez PromoDeep pour le site du marchand via un réseau d'affiliation
    (Awin, Amazon…). Ce réseau et le marchand peuvent alors déposer leurs propres cookies sur leur site, afin de
    nous verser une commission si vous achetez. Ces cookies relèvent de leur responsabilité et de leur bandeau
    cookies ; PromoDeep n'en dépose aucun sur son propre site.
  </p>

  <h2>Durée de votre choix</h2>
  <p>
    Quand le bandeau du site est affiché, votre choix (acceptation comme refus) est conservé 6 mois, puis nous vous
    le redemandons. Quand le message de Google est affiché, sa durée de conservation est fixée par Google. Dans les
    deux cas, vous pouvez le modifier à tout moment avec « Gérer mes cookies ». Si vous retirez votre accord, les
    traceurs concernés sont désactivés et leurs cookies supprimés de votre navigateur.
  </p>

  <h2>Vos droits</h2>
  <p>
    Vous pouvez aussi supprimer les cookies depuis les réglages de votre navigateur. Pour toute question sur vos
    données, consultez notre <a routerLink="/privacyPolicy">politique de confidentialité</a> ou
    <a routerLink="/contact">contactez-nous</a>. Vous pouvez également adresser une réclamation à la CNIL
    (<a href="https://www.cnil.fr" target="_blank" rel="noopener">www.cnil.fr</a>).
  </p>
</div>
